import type { IRemoteVideoTrack } from 'agora-rtc-sdk-ng';

/**
 * Remote screen-share tracks come through `user.videoTrack` like camera, but the underlying
 * MediaStreamTrack label (and sometimes Agora label) indicates capture/screen.
 */
export function isRemoteScreenVideoTrack(track: IRemoteVideoTrack | null | undefined): boolean {
  if (!track) return false;
  try {
    const mst = track.getMediaStreamTrack?.();
    const label = mst?.label ?? '';
    if (/screen|display|window|monitor|tab|web-contents|chrome|electron|entire/i.test(label)) {
      return true;
    }
    const agoraLabel = (track as { getTrackLabel?: () => string }).getTrackLabel?.();
    if (typeof agoraLabel === 'string' && /screen/i.test(agoraLabel)) return true;
  } catch {
    /* ignore */
  }
  return false;
}
